import React, { useState, useEffect } from 'react'
import ChatWidget from '../chat/ChatWidget'
import { ConversationProvider } from '../chat/ConversationContext'

const Layout = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null)

  const fetchCurrentUser = async () => {
    try {
      const response = await fetch('/api/v1/check_auth', {
        headers: {
          Accept: 'application/json',
        },
        credentials: 'same-origin',
      })

      if (response.ok) {
        const data = await response.json()
        console.log('Consumer auth check response:', data)
        setCurrentUser(data.current_user)
      } else {
        console.error('Consumer auth check failed with status:', response.status)
      }
    } catch (error) {
      console.error('Error fetching current user:', error)
    }
  }

  useEffect(() => {
    fetchCurrentUser()
  }, [])

  console.log('Consumer Layout render - currentUser:', currentUser)

  return (
    <>
      {currentUser ? (
        <ConversationProvider currentUser={currentUser}>
          {children}

          {/* Add ChatWidget for authenticated consumers */}
          <ChatWidget currentUser={currentUser} />
        </ConversationProvider>
      ) : (
        children
      )}
    </>
  )
}

export default Layout
